import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "post"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "flex space-between" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { class: "right" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 2,
  class: "form"
}
const _hoisted_16 = ["action"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "ar" }, "اسم")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "ar" }, "بريدك الإلكتروني")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Message "),
  /*#__PURE__*/_createElementVNode("span", { class: "ar" }, "الرسالة")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn red bc-red border submit"
  }, [
    /*#__PURE__*/_createTextVNode("Submit "),
    /*#__PURE__*/_createElementVNode("span", { class: "ar" }, "أرسل")
  ])
], -1)
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    id: "pageWrap",
    class: _normalizeClass(["view", {'scrolled': _ctx.scrolled}])
  }, [
    (_ctx.activePost)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.activePost.post_title), 1),
                (_ctx.activePost.ID == 527)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "تواصلوا معنا"))
                  : (_ctx.activePost.ID == 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "من نحن"))
                    : (_ctx.activePost.ID == 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "من نحن"))
                      : (_ctx.activePost.ID == 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "من نحن"))
                        : (_ctx.activePost.ID == 529)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "شاركونا خبر "))
                          : (_ctx.activePost.ID == 529)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "شاركونا خبر "))
                            : (_ctx.activePost.ID == 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "سياسة الخصوصية "))
                              : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.activePost.custom_fields.en)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "content",
                  innerHTML: _ctx.activePost.custom_fields.en.content
                }, null, 8, _hoisted_13))
              : _createCommentVNode("", true),
            (_ctx.activePost.custom_fields.ar)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "content arabic",
                  innerHTML: _ctx.activePost.custom_fields.ar.content
                }, null, 8, _hoisted_14))
              : _createCommentVNode("", true),
            (_ctx.activePost.ID == 527 || _ctx.activePost.ID == 529)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("form", {
                    id: "sendEmail",
                    onSubmit: _cache[3] || (_cache[3] = (...args) => (_ctx.checkForm && _ctx.checkForm(...args))),
                    action: _ctx.$route.query.page,
                    method: "get"
                  }, [
                    _hoisted_17,
                    _createElementVNode("p", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "name",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.name) = $event)),
                        placeholder: ""
                      }, null, 512), [
                        [_vModelText, _ctx.name]
                      ])
                    ]),
                    _hoisted_18,
                    _createElementVNode("p", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "email",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.email) = $event)),
                        placeholder: ""
                      }, null, 512), [
                        [_vModelText, _ctx.email]
                      ])
                    ]),
                    _hoisted_19,
                    _withDirectives(_createElementVNode("textarea", {
                      id: "message",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.message) = $event)),
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, _ctx.message]
                    ]),
                    _hoisted_20,
                    (_ctx.success != '')
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: "success",
                          innerHTML: _ctx.success
                        }, null, 8, _hoisted_21))
                      : _createCommentVNode("", true),
                    (_ctx.warning != '')
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 1,
                          class: "warning",
                          innerHTML: _ctx.warning
                        }, null, 8, _hoisted_22))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_16)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}